import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
import { UserTypes } from '../shared/interfaces';
import { permissions } from '../shared/permissions';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionRootRedirect implements CanActivate {
  constructor(
    private auth: AuthService,
    private userService: UserService,
    private router: Router,
  ) {}

  async canActivate(next: ActivatedRouteSnapshot) {
    const user = await this.userService.profile();

    if (user?.organization?.id === 1) {
      this.router.navigate(['/organization']);
      return false;
    }

    switch (user.type) {
      case UserTypes.VENDOR:
        this.router.navigate(['/inspection/vendor/flow']);
        break;
      case UserTypes.INSPECTOR:
        this.auth.logout();
        this.router.navigate(['/download/login']);
        break;
      case UserTypes.ADMIN:
        if (await this.userService.hasPermissions([permissions.INSPECTION.READ])) {
          return true;
          // this.router.navigate(['/inspection/flow']);
        } else {
          // go to blank page, so user can use the menu
          this.router.navigate(['/welcome']);
        }
        break;
    }

    return false;
  }
}
